import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { ClauseService } from 'gw-capability-policycommon';
import _ from 'lodash';
import { useCallback, useContext, useEffect, useState } from 'react';
import templateMetadata from '../config/PremierSC-wizard-config.json5';

const PATH_TO_MOCK_DATA = 'quote.PremierSC';
function createSubmissionObject(address, productCode) {
    const currentDate = new Date();
    const coverageStartDate = {
        day: currentDate.getDate(),
        month: currentDate.getMonth(),
        year: currentDate.getFullYear(),
    };
    const realData = {
        baseData: {
            policyAddress: address,
            periodStartDate: coverageStartDate,
            productCode,
        },
    };

    return MockUpUtil.setMockData(realData, PATH_TO_MOCK_DATA);
}

function removeMockData(data) {
    return MockUpUtil.cleanUpMockedProperties(
        data,
        PATH_TO_MOCK_DATA,
        'baseData.accountHolder.firstName',
        'baseData.accountHolder.lastName',
        'baseData.accountHolder.contactName',
        'baseData.accountHolder.displayName',
        'baseData.accountHolder.emailAddress1',
        'baseData.policyAddress.addressLine1',
        'baseData.policyAddress.city',
        'baseData.policyAddress.displayName'
    );
}

export default ({
    productCode,
    address,
    submission,
    externalPresentationMetadata,
}) => {
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [submissionVM, setSubmission] = useState(null);
    const [presentationMetadata, updatePresentationMetadata] = useState({});
    const [isCreatingSubmission, setIsCreatingSubmission] = useState(true);
    const [isSubmissionCreated, setIsSubmissionCreated] = useState(false);
    const [isFetchingWizardSteps, setIsFetchingWizardSteps] = useState(true);
    const [wizardSteps, setWizardSteps] = useState(null);
    const [wizardTitle, setWizardTitle] = useState(null);

    const viewModelService = useContext(ViewModelServiceContext);

    const createViewModel = useCallback(
        value => {
            return viewModelService.create(
                value,
                'pc',
                'edge.capabilities.quote.submission.dto.QuoteDataDTO'
            );
        },
        [viewModelService]
    );

    useEffect(() => {
        const loadSubmission = async () => {
            const metadata = !_.isEmpty(templateMetadata)
                ? templateMetadata
                : externalPresentationMetadata;

            updatePresentationMetadata(metadata);

            let viewModel;

            const isRetrieve = !_.isUndefined(submission);
            if (isRetrieve) {
                viewModel = createViewModel(submission);
                setSubmission(viewModel);
                ClausesUtil.getDependentClausesFromServer(
                    ClauseService,
                    _.get(submissionVM, 'quoteID.value')
                );
                setIsCreatingSubmission(false);
            } else if (viewModelService && !isSubmissionCreated) {
                const submissionToCreate = createSubmissionObject(
                    address,
                    productCode
                );
                const newSubmission = await LoadSaveService.createSubmission(
                    submissionToCreate
                );
                removeMockData(newSubmission);
                viewModel = createViewModel(newSubmission);
                setSubmission(viewModel);
                ClausesUtil.getDependentClausesFromServer(
                    ClauseService,
                    _.get(submissionVM, 'quoteID.value')
                );
                setIsCreatingSubmission(false);
                setIsSubmissionCreated(true);
            }

            setWizardTitle(
                _.get(metadata, [`${productCode}.default.wizard`, 'title'])
            );
            const availableSteps = _.get(metadata, [
                `${productCode}.default.wizard`,
                'steps',
            ]);

            setWizardSteps(availableSteps);
            setIsFetchingWizardSteps(false);
        };
        loadSubmission();
    }, [viewModelService]);

    return {
        submissionVM,
        wizardTitle,
        isFetchingWizardSteps,
        wizardSteps,
        presentationMetadata,
        isCreatingSubmission,
    };
};
